import { useNavigation } from '@react-navigation/native';
import { Button, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import { FooterButtonContainer } from 'components/sheets/SheetLayout';
import { useTranslation } from 'react-i18next';
import { ParkNavProps } from 'types/navigation';
import { testIdentifiers } from 'utils/testIdentifiers';

const ChargeIcon = () => {
  return <Icon name="Charging" color={theme.colors.white} />;
};

const ChargingHereButton = () => {
  const { navigate, goBack, canGoBack } = useNavigation<ParkNavProps>();
  const { t } = useTranslation();

  const handleOnPress = async () => {
    if (canGoBack()) {
      goBack();
    } else {
      navigate('park');
    }
  };

  return (
    <FooterButtonContainer pt={24}>
      <Button
        buttonType="primary"
        size="l"
        iconComponent={ChargeIcon}
        text={t('button.charge')}
        {...testIdentifiers('charging-here-button')}
        onPress={handleOnPress}
      />
    </FooterButtonContainer>
  );
};

export default ChargingHereButton;
